module.exports = __webpack_public_path__ + "static/media/truly_free_light.8bd22c73.svg";